import { Injectable } from '@angular/core';
import { LoadingService } from '../../layout/services/loading.service';
import { ModalController } from '@ionic/angular';
import { ModalAlertComponent } from 'src/app/views/themes/sentinel/modals/modal-alert/modal-alert.component';

@Injectable()
export class ModalService {
  constructor(private loadingService: LoadingService, private modalController: ModalController) { }

  public async notificationAlert(response: any) {
    this.loadingService.hide();

    const modalNotificationAlert = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: response.status,
        message: response.message,
        confirmation: response.confirmation,
        description: response.description,
        confirmBtn: response.confirmBtn,
        translate: response.translate,
      },
      backdropDismiss: response.backdropDismiss,
    });
    await modalNotificationAlert.present();
    return await modalNotificationAlert.onDidDismiss();
  }

  public async confirmationAlert(response: any) {
    this.loadingService.hide();

    const modal = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: response.status,
        message: response.message,
        confirmation: response.confirmation,
        description: response.description,
        confirmBtn: response.confirmBtn,
        cancelBtn: response.cancelBtn,
        translate: response.translate,
      },
      backdropDismiss: response.backdropDismiss,
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    return data;
  }
}
